import { FC } from 'react';

import { BlogSectionType } from '../../../models/Content';
import { StyledSectionVideo } from './SectionVideo.styles';
import { transformSectionVideo } from './transformers';

type Props = {
    contentItem: BlogSectionType;
};

export const SectionVideo: FC<Props> = ({ contentItem }) => {
    const { poster, video, subtitles, contentType } = transformSectionVideo(contentItem);

    if (!video) {
        return null;
    }

    return (
        <StyledSectionVideo controls={true} poster={poster}>
            <source src={video} type={contentType} />
            {subtitles && <track src={subtitles} kind="captions" />}
        </StyledSectionVideo>
    );
};
